import React from "react";
import { Link } from "react-router-dom";
import "../styles/client.css";

const clients = [
  { img: "Airtel.jpg", title: "Airtel Verification", desc: "Airtel Verification Process", link: "/Airtel-Verification" },
  { img: "Aircel.jpg", title: "Aircel Verification", desc: "Aircel Verification Process", link: "/aircel-verification" },
  { img: "VodaFone.jpg", title: "VodaFone Collection", desc: "VodaFone Collection Process", link: "/VodaFone-Collection" }, 
  { img: "AirtelSimProcess.png", title: "Airtel Sim Delivery", desc: "Airtel Sim Delivery Process", link: "/Airtel-SimDelivery" },
  { img: "Den.png", title: "Den Boom Band", desc: "Den Boom Band Process", link: "/Den-Retention" },
  { img: "Mobikwik.jpg", title: "Mobikwik Cash Pickup", desc: "Mobikwik Cash Pickup Process", link: "/Mobikwik" },
  { img: "AirtelRetention.png", title: "Airtel Retention", desc: "Airtel Retention Process", link: "/Airtel-Retention" },
  { img: "sbilogo1.png", title: "SBI CARD", desc: "SBI CARD Process" },
  { img: "bajaj1.png", title: "BAJAJ ALLIANZ", desc: "Bajaj Allianz Collection Process" },  
  { img: "boii.png", title: "BANK OF INDIA", desc: "BOI Process" },
  { img: "central.png", title: "CENTRAL BANK OF INDIA", desc: "Central Bank Process" },
  { img: "cscc.png", title: "COMMON SERVICE CENTER", desc: "Common Service Center Process" },
  { img: "idea.png", title: "IDEA", desc: "Idea Verification Process" },
  { img: "indusind.png", title: "IndusInd Bank", desc: "IndusInd Process" },
  { img: "Rbl.png", title: "RBL BANK", desc: "RBL Credit Card Process" },
  { img: "paytm1.png", title: "Pay TM", desc: "Pay TM Verification Process" },
  { img: "pb.png", title: "Punjab National Bank", desc: "PNB Process" },
  { img: "psbb.png", title: "Punjab & Sind Bank", desc: "PSB Process" },
  { img: "cbbi.png", title: "ICICI BANK", desc: "ICICI Collection Process" },
  { img: "cbii.png", title: "Central Bank", desc: "Central Bank Process" },
  { img: "Fresh.jpg", title: "Fresh Service", desc: "Fresh Process" },
  { img: "gv.png", title: "GV Service", desc: "GV Process" },
  { img: "er.jpg", title: "ER Service", desc: "ER Process" }
];

function Client() {
  return (
    <div className="client-section">
      <div className="client-container">
        {clients.map((c, index) => {
          const Card = (
            <div className="client-card">
              <img src={`/images/image nitish/Clients/${c.img}`} alt={c.title} />
              <h3>{c.title}</h3>
              <p>{c.desc}</p>
            </div>
          );

          return c.link ? (
            <Link to={c.link} key={index} style={{ textDecoration: "none", color: "inherit" }}>
              {Card}
            </Link>
          ) : (
            <div key={index}>{Card}</div>
          );
        })}
      </div>
    </div>
  );
}

export default Client;